module.exports = __webpack_public_path__ + "img/graphic-2-ru.e658f79d.png";